module.exports = {"510502001":"南城街道","510502002":"北城街道","510502003":"大山坪街道","510502004":"邻玉街道","510502005":"蓝田街道","510502006":"茜草街道","510502007":"华阳街道","510502009":"泰安街道","510502010":"况场街道","510502103":"黄舣镇","510502106":"通滩镇","510502107":"江北镇","510502108":"方山镇","510502109":"丹林镇","510502110":"分水岭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510502.json
// module id = 2416
// module chunks = 0